import routesCampaign from "./campaign";

const routes = [...routesCampaign];

export default routes;
